import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "global-container" }
const _hoisted_3 = { class: "contents-container" }
const _hoisted_4 = {
  key: 1,
  class: "mt-5 contact-container"
}
const _hoisted_5 = {
  key: 1,
  class: "my-2 px-2 address-container"
}

import HeaderComponent from '@/components/home/HeaderComponent.vue'
import { firestore as db } from '@/main'
import { Contact } from '@/types/Contact'
import { getDoc, doc } from 'firebase/firestore'
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { Delta, QuillEditor } from '@vueup/vue-quill'
import { GoogleMap, Marker, MarkerCluster } from 'vue3-google-map'
import CommonProgress from '@/components/common/CommonProgress.vue'

import '@vueup/vue-quill/dist/vue-quill.bubble.css'
import '@/styles/global.scss'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {

const contactItem = ref<Contact|undefined>(undefined)
const isLoading = ref(true)
const isEmailCopied = ref(false)
const isPhoneCopied = ref(false)
const isAddressCopied = ref(false)
const coords = computed(() => {
  if (contactItem.value?.latLng) {
    return {
      lat: Number(contactItem.value.latLng.split('N')[0]),
      lng: Number(contactItem.value.latLng.split('N')[1].split('E')[0])
    }
  } else {
    return {
      lat: 35.846595,
      lng: 127.132532
    }
  }
})
const contactDocRef = doc(db, 'Contact', 'Introduction')
const router = useRouter()
const apiKey = ref(process.env.VUE_APP_GOOGLE_MAPS_API_KEY)

function getContact () {
  isLoading.value = true

  getDoc(contactDocRef)
    .then((docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data()
        contactItem.value = {
          ...(data as Contact),
          contentsDelta: data.contents === '' || data.contents === undefined ? undefined : new Delta(JSON.parse(data.contents || '{}'))
        }
      }
    })
    .catch((e: Error) => {
      console.log(e.message)
    })
    .finally(() => {
      isLoading.value = false
    })
}

function copyToClipboard (type: 'tel' | 'email' | 'address') {
  if (type === 'tel' && contactItem.value?.tel) {
    navigator.clipboard.writeText(contactItem.value.tel)
      .then(() => {
        isPhoneCopied.value = true
        isEmailCopied.value = false
        isAddressCopied.value = false
      })
      .catch((e: Error) => {
        console.log(e.message)
      })
  } else if (type === 'email' && contactItem.value?.email) {
    navigator.clipboard.writeText(contactItem.value.email)
      .then(() => {
        isEmailCopied.value = true
        isPhoneCopied.value = false
        isAddressCopied.value = false
      })
      .catch((e: Error) => {
        console.log(e.message)
      })
  } else if (type === 'address' && contactItem.value?.address) {
    navigator.clipboard.writeText(contactItem.value.address)
      .then(() => {
        isAddressCopied.value = true
        isPhoneCopied.value = false
        isEmailCopied.value = false
      })
      .catch((e: Error) => {
        console.log(e.message)
      })
  }
}

onMounted(() => {
  getContact()
})

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(HeaderComponent, {
              title: 'Welcome to SBL',
              "trailing-icon": 'fa-solid fa-edit',
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({
            name: 'modifyContact',
            state: {
              data: {
                address: contactItem.value?.address ?? '',
                contents: contactItem.value?.contents ?? '',
                email: contactItem.value?.email ?? '',
                latLng: contactItem.value?.latLng ?? '',
                tel: contactItem.value?.tel ?? ''
              }
            }
          })))
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            (isLoading.value)
              ? (_openBlock(), _createBlock(CommonProgress, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_v_img, {
                    src: contactItem.value?.image,
                    width: "100%",
                    "max-width": "100%"
                  }, null, 8, ["src"]),
                  (contactItem.value?.contentsDelta)
                    ? (_openBlock(), _createBlock(_unref(QuillEditor), {
                        key: 0,
                        class: "mt-2",
                        content: contactItem.value.contentsDelta,
                        "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => ((contactItem.value.contentsDelta) = $event)),
                        options: { readOnly: true, theme: 'bubble', modules: { toolbar: false } }
                      }, null, 8, ["content"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_row, { class: "my-2" }, {
                    default: _withCtx(() => [
                      (contactItem.value?.tel !== '')
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "mt-2 mr-2 action",
                            variant: "outlined",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (copyToClipboard('tel')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(isPhoneCopied.value ? 'Copied!' : contactItem.value?.tel) + " ", 1),
                              (!isPhoneCopied.value)
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    icon: "fa-solid fa-clipboard"
                                  }))
                                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 1,
                                    icon: "fa-solid fa-clipboard-check"
                                  }))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (contactItem.value?.email !== '')
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            class: "mt-2 action",
                            variant: "outlined",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (copyToClipboard('email')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(isEmailCopied.value ? 'Copied!' : contactItem.value?.email) + " ", 1),
                              (!isEmailCopied.value)
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    icon: "fa-solid fa-clipboard"
                                  }))
                                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 1,
                                    icon: "fa-solid fa-clipboard-check"
                                  }))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(GoogleMap), {
                    "api-key": apiKey.value,
                    class: "maps",
                    center: coords.value,
                    zoom: 15,
                    language: "en"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MarkerCluster), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Marker), {
                            options: { position: coords.value }
                          }, null, 8, ["options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["api-key", "center"]),
                  (contactItem.value?.address !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createTextVNode(_toDisplayString(contactItem.value?.address) + " ", 1),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          class: "ml-2 action",
                          variant: "outlined",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (copyToClipboard('address')))
                        }, {
                          default: _withCtx(() => [
                            (!isAddressCopied.value)
                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 0,
                                  icon: "fa-solid fa-clipboard"
                                }))
                              : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 1,
                                  icon: "fa-solid fa-clipboard-check"
                                }))
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})